import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=447cc87c&scoped=true&"
import script from "./PageHeader.vue?vue&type=script&lang=js&"
export * from "./PageHeader.vue?vue&type=script&lang=js&"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=447cc87c&prod&lang=scss&"
import style1 from "./PageHeader.vue?vue&type=style&index=1&id=447cc87c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447cc87c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainMenu: require('/home/vsts/work/1/s/components/MainMenu.vue').default})
